import { Link, useParams } from 'react-router-dom';

export function CustodianExceptionDetailPage() {
  const { exceptionId } = useParams();

  return (
    <div className="page-stack">
      <div className="flex flex-wrap items-center gap-2 text-xs text-evault-muted">
        <Link
          to="/custodian/exceptions"
          className="font-semibold text-evault-teal hover:underline"
        >
          Exceptions
        </Link>
        <span aria-hidden>/</span>
        <span className="text-umb-neutral-dark">{exceptionId}</span>
      </div>

      <section className="card-shell p-5 sm:p-6">
        <h2 className="text-sm font-semibold text-umb-neutral-dark">
          Custody exception
        </h2>
        <p className="mt-1 text-xs text-evault-muted">
          Remediation workspace: evidence compare, state correction, and route
          back to provider when needed.
        </p>
        <ul className="mt-4 list-disc space-y-1 pl-5 text-sm text-umb-neutral-dark/85">
          <li>Linked asset: A-18721</li>
          <li>Blocking action: Admission review</li>
          <li>Suggested cure: Request updated collateral schedule from provider</li>
        </ul>
        <div className="mt-6 flex flex-wrap gap-2">
          <button
            type="button"
            className="rounded-full bg-evault-teal px-4 py-2 text-xs font-semibold text-white shadow-sm hover:bg-evault-teal-hover"
          >
            Request clarification
          </button>
          <button
            type="button"
            className="rounded-full border border-evault-border bg-white px-4 py-2 text-xs font-semibold text-evault-select-text hover:bg-evault-select-bg"
          >
            Mark resolved
          </button>
        </div>
      </section>
    </div>
  );
}
